/*
* Overview of available master enums is defined in the framework.
* Use this enum to reference master enum class names that are shared across modules.
*/
export enum EnumClassNameMasterEnum {
    SEASON = "DigitalPharma\\Base\\Model\\PhpEnum\\SeasonEnum",
}
